import { MFormTextField } from 'src/lib';
import { Account } from 'src/models';

import {
  ANNUAL_INCOME_TOOLTIP_TEXT,
  LIQUID_NET_WORTH_TOOLTIP_TEXT,
  TOTAL_NET_WORTH_TOOLTIP_TEXT,
} from './tooltips.constants';

export interface FinancialInformationAssetsViewProps {
  account?: Account;
}

export const FinancialInformationAssetsView = ({ account }: FinancialInformationAssetsViewProps) => {
  return (
    <>
      <MFormTextField
        label='Annual Income'
        value={account?.financialAssets?.annualIncome?.label}
        tooltip={{
          type: 'popover',
          content: ANNUAL_INCOME_TOOLTIP_TEXT,
          icon: 'info',
        }}
        testId={'account-annual-income'}
      />
      <MFormTextField
        label='Total Net Worth'
        value={account?.financialAssets?.totalNetWorth?.label}
        tooltip={{
          type: 'popover',
          content: TOTAL_NET_WORTH_TOOLTIP_TEXT,
          icon: 'info',
        }}
        testId={'account-total-net-worth'}
      />
      <MFormTextField
        label='Liquid Net Worth'
        value={account?.financialAssets?.liquidNetWorth?.label}
        tooltip={{
          type: 'popover',
          content: LIQUID_NET_WORTH_TOOLTIP_TEXT,
          icon: 'info',
        }}
        testId={'account-liquid-net-worth'}
      />
      <MFormTextField
        label='Tax Bracket'
        value={account?.financialAssets?.taxBracket?.label}
        testId={'account-tax-bracket'}
      />
    </>
  );
};
